export function isIPhone() {
  return /iPhone/i.test(navigator.userAgent);
}
